import { Grid, InputAdornment, Typography } from "@mui/material";
import { OLPaper } from "OLPaper";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { TextInput } from "components/FormControls/TextInput";
import { ReactComponent as HelpCircleIcon } from "components/Icons/help-circle.svg";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useMessage } from "hooks/intl";
import { useStyles } from "./WalletType.styles";
import { WalletTypeNameSection } from "./WalletTypeNameSection";

export function BasicSettings(props: { editMode?: boolean }) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <>
      <OLPaper className={classes.OLPaper}>
        <Grid container className={classes.displayColumn}>
          <Grid item>
            <WalletTypeNameSection />
          </Grid>
          <Grid item>
            <section>
              <Grid container spacing={10}>
                <Grid xs item>
                  <TextInput
                    className={classes.fullWidth}
                    data-test-id="code-input"
                    disabled={props.editMode}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip
                            text={
                              <Typography className={classes.tooltipTitle}>
                                {message({ id: "walletCodeInfo" })}
                              </Typography>
                            }
                          >
                            <HelpCircleIcon className={classes.tooltipIcon} />
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                    label={
                      <RequiredFieldLabel
                        text={message({ id: "walletCode" })}
                      />
                    }
                    name="code"
                  />
                </Grid>
              </Grid>
            </section>
          </Grid>
        </Grid>
      </OLPaper>
    </>
  );
}
